import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Box, Typography } from '@mui/material';
import React from 'react';

interface BadgeCheckInModalInfoLineProps {
    name: string;
    data?: string;
    width?: number;
}

export const BadgeCheckInModalInfoLine: React.FC<BadgeCheckInModalInfoLineProps> = ({ name, data, width = 88 }) => (
    <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2, wordBreak: 'break-word' }}>
        <Typography variant='body2' sx={{ color: themeColors.text.subtle, minWidth: width, maxWidth: width }}>
            {name}
        </Typography>
        <Typography variant='body2'>{data || '-'}</Typography>
    </Box>
);
